<template>
    <!-- 全局搜索的搜索框，点击后将跳到搜索页 -->
    <div class="search" @click="go2search">
        <van-icon name="search"/>搜索
    </div>
</template>

<script>

export default {
    name: "GlobalSearchBar",
    methods:{
        go2search(){
            this.$router.push('/search')
        }
    }
}
</script>

<style scoped>
.search{
    background: rgba(255, 255, 255, 0.47);
    border-radius: 4vw;
    height: 8vw;
    text-align: center;
    line-height: 8vw;
    color: #7AADC8;
    font-family: "PingFang SC";
    cursor: pointer;
}
</style>
